<template>
   <div class="w-100 p-3" style="height: 75vh;overflow-y: auto;">
      
      <div class="d-flex flex-justify-start">
         <div class="filter-left">
            <label class="text-bold">{{ $t("Search") }}</label>
            <input v-model="processesList_filters.nameToSearch" type="text" data-role="input" data-clear-button="true" :placeholder="$t('Please enter at least 4 characters to start the search.')">
         </div>
         <div class="filter-left">
            <label class="text-bold">{{ $t("Username") }}</label>
            <select class="pl-4 select  text-small w-auto" v-model="processesList_filters.selectedUsername">
               <option value="">{{ $t("All") }}</option>
               <option v-for="u in processesList_filters.usernamesList" :value="u">{{ u }}</option>
            </select>
         </div>
      </div>
	   <div class="w-100 text-center" v-if="status == $ResultValue.Running">
         <span class="mif-spinner2 ani-spin mif-3x"></span>
      </div>      <NoDataAvailable v-if="status == $ResultValue.SomeWarnings" :message="$t('No process available')" />
      <div v-if="status == $ResultValue.OK">
         <table class="bg-white border table striped compact overflow" v-if="processesList.length != 0" >
            <thead>
               <tr>
                  <th class="w-10 text-center">PID</th>
                  <th class="w-40">{{ $t("Name") }}</th>
                  <th class="w-25 text-center">{{ $t("Username") }}</th>
                  <th class="w-20">{{ $t("Memory") }} </th>
                  <th style="width: 10px;"></th>
               </tr>
            </thead>
            <tbody>
               <tr v-for="(process, index) in processesList" :key="process.pid" :track-by="process.pid" 
                  v-show="(processesList_filters.nameToSearch == '' || process.name.toLowerCase().contains(processesList_filters.nameToSearch.toLowerCase())) && ['', process.username].includes(processesList_filters.selectedUsername)">
                  <td class="text-center">{{ process.pid }}</td>
                  <td>{{ process.name }}</td>
                  <td class="text-center">{{ process.username }}</td>
                  <td>{{ process.ram | prettyBytes }}</td>
                  <td class="text-center"><a :href="'#killprocess_' + process.pid">
                     <span class="text-bold mif mif-cross fg-red"></span></a>
                  </td>
               </tr>
            </tbody>
         </table>
      </div>
   </div>
</template>
<script>
import { getValueOrDefault, prettyBytes } from '../../utils/utilitiesmodule';
import NoDataAvailable from '../utils/NoDataAvailable.vue';

export default {
	name: "TaskManager",
	components: {
		NoDataAvailable
	},

	beforeDestroy() {
		this.$root.$off("addRealTimeProcessesToPage");
	},

	data() {
		return {
			status: this.$ResultValue.Running,
			processesList: null, // socket realtime
			processesList_filters: {
				nameToSearch: "",
				usernamesList: [],
				selectedUsername: "",
				showList: true
			},
		}
	},
	methods: {
		startRetrieveProcessList() {
			if (this.status!=this.$ResultValue.Running)
				return;
			let self=this;
			this.$root.$on("addRealTimeProcessesToPage", rt_processesList => {

				if (self.processesList==null) {
					self.processesList=[];
				}

				self.processesList.update(getValueOrDefault(rt_processesList, []));
				if (self.processesList.length==0) {
					this.status=this.$ResultValue.SomeWarnings;
				} else {
					this.status=this.$ResultValue.OK;
				}
				if (self.processesList_filters.usernamesList.length!=0)
					return;
				self.processesList_filters.usernamesList=rt_processesList.map(p => p.username).distinctBy(null);
			});
		}
	},
	filters: {
        prettyBytes: function(bytes, precision) {
            return prettyBytes(bytes, precision);
        },
    },
}
</script>